<script>
import NebModal from '@/components/Nebula/layout/Modal'
import NebButton from '@/components/Nebula/controls/Button'
import NebFormControl from '@/components/Nebula/controls/FormControl'

export default {
  name: 'DeleteConfirmModal',

  components: {
    NebModal,
    NebButton,
    NebFormControl
  },

  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    collectionName: {
      type: String,
      default: 'Unknown'
    }
  },

  emits: [
    'action:close'
  ],

  setup (_, { emit }) {

    const handleClose = () => emit('action:close')
    const handleDelete = () => emit('action:delete')

    return {
      handleClose,
      handleDelete
    }
  }
}
</script>

<template>
  <neb-modal title="Delete Collection" :isOpen="isOpen"
    @clickOutside="handleClose"
  >
    <p>Are  you sure you want to delete the collection "{{collectionName}}"?</p>

    <template #footer>
      <neb-form-control align="end">
        <neb-button @click="handleClose">Cancel</neb-button>
        <neb-button type="danger"
          @click="handleDelete"
        >
          Delete
        </neb-button>
      </neb-form-control>
    </template>
  </neb-modal>
</template>
